import { dcsLog } from './logger';

/**
 * 取访客真实公网 IP —— 仅用于人工 IM 模式建会话时上送给 IM 侧查归属地。
 *
 * 浏览器无法原生拿到自身公网 IP,故走 iwanshang 自有回显服务
 * (GET https://ip.iwanshang.cloud/remoteAddress → {"code":200,"ip":"1.2.3.4"})。
 * 该域名环境无关、国内可达;允许 VITE_CLIENT_IP_URL 覆盖。
 *
 * IP 是 best-effort:超时 / 不可达 / 非 200 一律静默返回 null,绝不抛错,
 * 不能阻塞建会话(拿不到则不带 client_ip,IM 回退用自己入口看到的连接 IP)。
 * 结果按页面生命周期缓存,只请求一次(公网 IP 一次会话内基本不变)。
 */

const IP_ECHO_URL =
  (import.meta.env.VITE_CLIENT_IP_URL as string | undefined) ??
  'https://ip.iwanshang.cloud/remoteAddress';

const TIMEOUT_MS = 1500;

// undefined = 未取过; string = 取到的 IP; null = 取过但失败/无值
let cached: string | null | undefined;

export async function fetchClientIp(): Promise<string | null> {
  if (cached !== undefined) return cached;
  try {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), TIMEOUT_MS);
    let res: Response;
    try {
      res = await fetch(IP_ECHO_URL, { signal: ctrl.signal, credentials: 'omit' });
    } finally {
      clearTimeout(timer);
    }
    const data = (await res.json()) as { code?: number; ip?: string };
    cached = data?.code === 200 && typeof data.ip === 'string' ? data.ip : null;
  } catch (err) {
    dcsLog.warn('client-ip', '获取公网 IP 失败,降级不带 IP', err);
    cached = null;
  }
  return cached;
}

/** 仅测试用 — 隔离单测之间缓存 */
export function resetClientIpCache(): void {
  cached = undefined;
}
